









































import { Component, Prop, Vue } from "vue-property-decorator";

const regex = /(.*?):(.*)/;

@Component
export default class StringlistProperty extends Vue {

    @Prop({ type: String })
    name!: string;

    @Prop({ type: Array })
    value!: string[];

    text = "";

    get entries() {
        return this.value ?
            this.value.map((s) => {
                const res = regex.exec(s);
                if (res && res.length === 3) {
                    return [res[2], res[1]];
                } else {
                    return [s, ""];
                }
            }) : [];
    }

    add() {
        const newValue = (this.value || []).concat([this.text]);
        this.$emit("input", newValue);
        this.text = "";
    }

    edit(index: number) {
        this.text = this.value[index];
        this.remove(index);
    }

    remove(index: number) {
        const clonedArray = this.value.slice(0);
        clonedArray.splice(index, 1);
        this.$emit("input", clonedArray);
    }

}
